import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AccountEndpoint } from './account-endpoint.service';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})

export class AccountService {

  constructor(private accountEndpoint: AccountEndpoint) {

  }

  getUser(userId: string): Observable<User> {
    return this.accountEndpoint.getUserEndpoint<User>(userId);
  }
}
